/**
 * Cookie consent banner.
 *
 * - Non-necessary categories are off by default.
 * - "Akkoord" / "Nee, liever niet" are equally available, plus per-category
 *   preferences.
 * - The choice is recorded server-side (proof) and mirrored into an encrypted
 *   cookie, and Google Consent Mode is updated so non-necessary cookies are
 *   only placed after consent.
 */
(function () {
    const banner = document.querySelector('[data-cookie-banner]');
    const preferences = document.querySelector('[data-cookie-preferences]');

    if (!banner) {
        return;
    }

    const storeUrl = banner.getAttribute('data-cookie-store-url');
    const token = banner.getAttribute('data-cookie-token');

    const consentModeSignals = {
        analytics: ['analytics_storage'],
        marketing: ['ad_storage', 'ad_user_data', 'ad_personalization'],
    };

    function applyConsent(prefs) {
        if (typeof window.gtag !== 'function') {
            return;
        }

        const update = {};

        Object.keys(consentModeSignals).forEach(function (category) {
            const granted = prefs[category] ? 'granted' : 'denied';

            consentModeSignals[category].forEach(function (signal) {
                update[signal] = granted;
            });
        });

        window.gtag('consent', 'update', update);
    }

    function openPreferences() {
        if (preferences) {
            preferences.hidden = false;
            document.body.classList.add('cookie-no-scroll');
        }
    }

    function closePreferences() {
        if (preferences) {
            preferences.hidden = true;
            document.body.classList.remove('cookie-no-scroll');
        }
    }

    function hideBanner() {
        banner.hidden = true;
    }

    function readSelectedPreferences() {
        const prefs = { analytics: false, marketing: false };

        document.querySelectorAll('[data-cookie-category]').forEach(function (input) {
            prefs[input.getAttribute('data-cookie-category')] = input.checked;
        });

        return prefs;
    }

    function reflectPreferences(prefs) {
        document.querySelectorAll('[data-cookie-category]').forEach(function (input) {
            input.checked = !!prefs[input.getAttribute('data-cookie-category')];
        });
    }

    function save(prefs) {
        fetch(storeUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN': token,
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
                analytics: prefs.analytics ? 1 : 0,
                marketing: prefs.marketing ? 1 : 0,
            }),
        })
            .then(function () {
                applyConsent(prefs);
                hideBanner();
                closePreferences();
            })
            .catch(function () {
                // Still reflect the choice client-side so the visitor is not
                // blocked if the request fails.
                applyConsent(prefs);
                hideBanner();
                closePreferences();
            });
    }

    function bindAll(selector, handler) {
        document.querySelectorAll(selector).forEach(function (element) {
            element.addEventListener('click', handler);
        });
    }

    bindAll('[data-cookie-accept]', function () {
        const prefs = { analytics: true, marketing: true };
        reflectPreferences(prefs);
        save(prefs);
    });

    bindAll('[data-cookie-reject]', function () {
        const prefs = { analytics: false, marketing: false };
        reflectPreferences(prefs);
        save(prefs);
    });

    bindAll('[data-cookie-save]', function () {
        save(readSelectedPreferences());
    });

    bindAll('[data-cookie-open]', function () {
        openPreferences();
    });

    bindAll('[data-cookie-close]', function () {
        closePreferences();
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && preferences && !preferences.hidden) {
            closePreferences();
        }
    });
})();
